// extracted by mini-css-extract-plugin
module.exports = {"StockShortsPage":"short-interest_StockShortsPage__oTRqx","asOf":"short-interest_asOf__UcZow"};